import { createBlockStyleButton } from '@draft-js-plugins/buttons';
import unorderedListIcon from '@sb1/ffe-icons/icons/open/300/md/format_list_bulleted.svg';
import { Icon } from '@sb1/ffe-icons-react';

export const UnorderedListButton = createBlockStyleButton({
    blockType: 'unordered-list-item',
    children: <Icon fileUrl={unorderedListIcon} />,
});
